module.exports = __webpack_public_path__ + "static/media/trash.e509200c.svg";